import { r as s, h as t } from "./index-6e735f92.js";
import "react";
import "react/jsx-runtime";
import "react-dom";
const o = ".sc-trash-fill-icon-h{display:flex}", a = o, i = class {
  constructor(e) {
    s(this, e), this.width = "15", this.height = "15";
  }
  render() {
    return t("svg", { key: "ad2097e898ad6426697c0be069096cba0bce325d", width: this.width, height: this.height, viewBox: "0 0 24 24", fill: "auto", xmlns: "http://www.w3.org/2000/svg" }, t("path", { key: "5069815e3a78b039700962c41f82fe83a9911787", d: "M3 6H5H21", stroke: "auto", "stroke-width": "1.5" }), t("path", { key: "709eb0e7ba963e5f06bf2686e3cb7575034bf396", d: "M8 6V4C8 3.46957 8.21071 2.96086 8.58579 2.58579C8.96086 2.21071 9.46957 2 10 2H14C14.5304 2 15.0391 2.21071 15.4142 2.58579C15.7893 2.96086 16 3.46957 16 4V6M19 6V20C19 20.5304 18.7893 21.0391 18.4142 21.4142C18.0391 21.7893 17.5304 22 17 22H7C6.46957 22 5.96086 21.7893 5.58579 21.4142C5.21071 21.0391 5 20.5304 5 20V6H19Z", stroke: "auto", "stroke-width": "1.5" }), t("path", { key: "65f9c4e6f7f5bb3776bebaeb4ab5daef8ca99cfb", d: "M10 11V17", stroke: "auto", "stroke-width": "1.5" }), t("path", { key: "97555b9bba0b031d02856bffc99db16fa1225966", d: "M14 11V17", stroke: "auto", "stroke-width": "1.5" }));
  }
};
i.style = a;
export {
  i as trash_fill_icon
};
